import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import Button from "./Button";
import { CONFIG } from "../config/config";
import toast from 'react-hot-toast';
import { useUser } from '../context/UserContext';

export default function PdfImporter({ onPatientImported }) {
  const [error, setError] = useState("");
  const {etablissement} = useUser();

  const onDrop = useCallback(
    async (acceptedFiles) => {
      setError("");
      const file = acceptedFiles[0];
      const form = new FormData();
      form.append("pdf", file);
      form.append("etablissement_id", etablissement.etablissement_id)

      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token");

      try {
        const res = await fetch(`${CONFIG.API_URL}/import-pdf`, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: form,
        });

        if (!res.ok) {
          let msg = `Import failed (${res.status})`;
          try {
            const errBody = await res.json();
            if (errBody.error) msg = errBody.error;
          } catch {}
          throw new Error(msg);
        }

        // on récupère le row SQL
        const row = await res.json();
        // on en extrait uniquement les champs bruts pour le PDF
        const parsed = {
          nom: row.nom,
          prenom: row.prenom,
          date_naissance: row.date_naissance,
          doctolib_id: row.doctolib_id,
        };

        // on laisse Arrivee décider si c'est complet ou pas
        onPatientImported(parsed);
      } catch (err) {
        console.error(err);
        setError(err.message);
        toast.error(err.message);
      }
    },
    [onPatientImported],
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "application/pdf": [".pdf"] },
    multiple: false,
  });

  return (
    <div>
      <div
        {...getRootProps()}
        className={`
          border-2 border-dashed border-red-300 rounded p-6 text-center
          ${isDragActive ? "bg-red-50" : "bg-white"}
        `}
      >
        <input {...getInputProps()} />
        <p>Dépose ton PDF Doctolib ici pour importer un patient</p>
        <Button className="mt-4">Ou clique pour sélectionner un fichier</Button>
      </div>
      {error && (
        <p className="mt-2 text-sm text-red-600 text-center">{error}</p>
      )}
    </div>
  );
}
